import { render } from "./TreeMove.vue?vue&type=template&id=432887d4&scoped=true"
import script from "./TreeMove.js?vue&type=script&lang=js"
export * from "./TreeMove.js?vue&type=script&lang=js"

import "./TreeMove.vue?vue&type=style&index=0&id=432887d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432887d4"]])

export default __exports__